import { combineReducers } from 'redux';
import * as PopUpDetailsContentConstant from './actions';

const status = (state = false, action) => {
  switch (action.type) {
    case PopUpDetailsContentConstant.CHANGE_POPUP_DETAILS_VIEW_STATE:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  status
});

export const getPopUpDetailsStatus = state => {
  return state.user.snd.popUpDetails.status;
};
